module.exports = __webpack_public_path__ + "static/media/business.07cfcad7.svg";